<template>
    <div ref="bannerContainer" :class="['banner-container', currentStyle]">
        <el-carousel :height="carouselHeight" v-if="value.data && value.data.length > 0">
            <el-carousel-item v-for="(item, index) in value.data" :key="index">
                <a :href="item.link" :class="{ 'pointer-events-none': !item.link }" target="_blank"
                    rel="noopener noreferrer">
                    <img :src="decodeURIComponent(item.url)">
                </a>
            </el-carousel-item>
        </el-carousel>
        <NullView v-else tip="[轮播图]" :height="160" />
    </div>
</template>

<script>
import NullView from "./NullView";

export default {
    name: 'BannerView',
    components: {
        NullView
    },
    props: {
        currentStyle: {
            type: String,
            default: () => ''
        },
        value: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            carouselHeight: '176px'
        }
    },
    mounted() {
        this.$nextTick(() => {
            const checkWidth = () => {
                const width = this.$refs.bannerContainer.offsetWidth;
                if (width > 0) {
                    this.carouselHeight = width / 2 + 'px';
                } else {
                    setTimeout(checkWidth, 100);
                }
            };

            // 开始第一次检查
            checkWidth();
        });
    }
}
</script>

<style lang="scss" scoped>
.banner-container {
    width: 100%;

    img {
        width: 100%;
        height: 100%;
    }

    .el-carousel__indicator--horizontal {
        padding: 12px 4px;
    }

    .el-carousel__button {
        width: 12px;
    }

    &.style1 {
        // 基础样式
    }
}
</style>